var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links-container"},_vm._l((_vm.LinkNamesList),function(link,index){return _c('a',{key:`${link + index}`,attrs:{"download":`${link}.pdf`,"href":`${_vm.publicPath + link}.pdf`,"rel":"PDF"}},[_vm._v(" "+_vm._s(link)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }